

























import { defineComponent, reactive, ref,watch } from '@vue/composition-api'
import { Message } from 'element-ui'
import useRootSetting from '@/hooks/useRootSetting';
export default defineComponent({
  name: 'Import',
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
  },
  setup(props, { emit }) {
    const {getIsMobile} = useRootSetting()
    const upload = ref(null)
    const uploadInfoRef = ref(null)
    const upLoading = ref(false)
    const fileList = ref([])
    const action = ref(`${process.env.VUE_APP_NONE_API}/price_upload_excel.php`)
    const rules = reactive({
      fileId: [{
        required: true,
        message: '请上传文件',
        trigger: 'change'
      }]
    })
    const uploadInfo = reactive({
      fileId: ''
    })

    // const handleSubmit = () => {
    //   uploadInfoRef.value.validate(async (valid) => {
    //     if (valid) {
    //       emit('submit')
    //     }
    //   })
    // }
    const beforeUpload = (file) =>{
      // 仅允许 Excel 文件
      const isExcel =
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";

      if (!isExcel) {
        Message.error("只能上传 Excel 文件 (.xls/.xlsx)");
        return false;
      }

      return true;
    }
    const uploadSuc = (e) => {
      if(e.code == 200) {
        Message.success(e.msg)
        emit('uploadSuccess')
      }else if(e.code == 300) {
        Message.error(e.msg)
      }else if(e.code == 400) {
        fileList.value = []
        Message.error(e.msg)
      }
    }
    const cancelExcel = () => {
      uploadInfo.fileId = ''
    }
    const uploadFail = (e) => {
      console.log('上传失败', e)
    }
    //导入下载模板
    const handleDown = () => {
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['品牌','型号','原币价格']
        const filterVal = ['source','xhname','price']
        const data = [
          ["SKF", 16002, 10]]; // 示例数据
        (excel.export_json_to_excel as any)({
          header: tHeader,
          data,
          filename: '价格列表'
        })
      })
    }

    const handleClose = () => {
      emit('close')
    }

    watch(()=>props.dialog,(val)=>{
      if(val) {
        fileList.value = []
      }
    },{immediate:true})
    return {
      action,
      fileList,
      getIsMobile,
      upLoading,
      uploadInfoRef,
      upload,
      uploadInfo,
      rules,
      handleClose,
      beforeUpload,
      handleDown,
      uploadSuc,
      uploadFail,
      cancelExcel
    }
  }
})
